/**
 * 物流管理模块 - 枚举定义
 * 
 * @module logistics
 * @version 1.0.0
 * @since 2026-01-23
 */

/**
 * 物流供应商类型
 */
export enum LogisticsProviderType {
  /** 快递 */
  EXPRESS = 1,
  /** 整车物流 */
  FULL_TRUCK = 2,
  /** 零担物流 */
  LTL = 3,
  /** 冷链物流 */
  COLD_CHAIN = 4,
  /** 专线物流 */
  SPECIAL_LINE = 5,
}

/**
 * 企业类型（物流供应商）
 */
export enum LogisticsCompanyType {
  /** 国企 */
  STATE_OWNED = 1,
  /** 民企 */
  PRIVATE = 2,
  /** 外企 */
  FOREIGN = 3,
  /** 个体 */
  INDIVIDUAL = 4,
}

/**
 * 结算方式
 */
export enum SettlementType {
  /** 现结 */
  CASH = 1,
  /** 月结 */
  MONTHLY = 2,
  /** 预付 */
  PREPAID = 3,
}

/**
 * 物流供应商状态
 */
export enum LogisticsProviderStatus {
  /** 停用 */
  DISABLED = 0,
  /** 启用 */
  ENABLED = 1,
}

/**
 * 物流订单状态
 */
export enum LogisticsOrderStatus {
  /** 待揽收 */
  PENDING = 1,
  /** 运输中 */
  IN_TRANSIT = 2,
  /** 已签收 */
  SIGNED = 3,
  /** 已取消 */
  CANCELLED = 4,
  /** 异常 */
  EXCEPTION = 5,
}

/**
 * 物流轨迹来源
 */
export enum LogisticsTrackSource {
  /** 手动录入 */
  MANUAL = 'MANUAL',
  /** API接口 */
  API = 'API',
}

/**
 * 结算单状态
 */
export enum LogisticsSettlementStatus {
  /** 待导入 */
  PENDING_IMPORT = 1,
  /** 待核对 */
  PENDING_CHECK = 2,
  /** 待确认 */
  PENDING_CONFIRM = 3,
  /** 已确认 */
  CONFIRMED = 4,
  /** 已付款 */
  PAID = 5,
}

/**
 * 结算明细匹配状态
 */
export enum SettlementItemMatchStatus {
  /** 未匹配 */
  NOT_MATCHED = 0,
  /** 已匹配 */
  MATCHED = 1,
  /** 有差异 */
  DIFFERENCE = 2,
  /** 系统多 */
  SYSTEM_EXTRA = 3,
  /** 账单多 */
  IMPORT_EXTRA = 4,
}

